import PropTypes from 'prop-types';
import React from 'react';

import {
  OK,
  PERMANENT_REDIRECT_STATUS,
  TEMPORARY_REDIRECT_STATUS,
} from '@glass/common/modules/http/statusCodes';

import redirect from '@glass/shared/modules/router/redirect';

const withErrorPage = (ErrorPage) => (Component) => {
  function ComponentWithErrorPage(props) {
    const { statusCode, location } = props;

    if (location && [TEMPORARY_REDIRECT_STATUS, PERMANENT_REDIRECT_STATUS].includes(statusCode)) {
      redirect(undefined, location, { status: statusCode });
      return null;
    }
    if (statusCode > OK) {
      return <ErrorPage {...props} statusCode={statusCode} />;
    }

    return <Component ErrorPage={ErrorPage} {...props} />;
  }

  ComponentWithErrorPage.propTypes = {
    location: PropTypes.string,
    statusCode: PropTypes.number,
  };

  ComponentWithErrorPage.defaultProps = {
    statusCode: OK,
  };

  if (typeof Component.getInitialProps === 'function') {
    ComponentWithErrorPage.getInitialProps = Component.getInitialProps;
  }

  return ComponentWithErrorPage;
};

export default withErrorPage;
